"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_i18next_1 = require("react-i18next");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var pro_solid_svg_icons_1 = require("@fortawesome/pro-solid-svg-icons");
var q_play_core_1 = require("@nordicscreen/q-play-core");
var q_play_components_1 = require("@nordicscreen/q-play-components");
var q_play_components_2 = require("@nordicscreen/q-play-components");
var AppIntegrations_module_css_1 = __importDefault(require("./AppIntegrations.module.css"));
var AccessControl_1 = __importDefault(require("../common/AccessControl"));
var types_1 = require("@/Types/types");
var AppIntegrationHelper_1 = __importDefault(require("./AppIntegrationHelper"));
var AppIntegrationResourceAccordion_1 = __importDefault(require("./AppIntegrationResourceAccordion"));
var TypeGuards_1 = require("@/functions/TypeGuards");
var AppIntegrationEditor = function (props) {
    var _a, _b;
    var t = (0, react_i18next_1.useTranslation)("translation", { useSuspense: true }).t;
    var _c = (0, react_1.useState)(undefined), appIntegrationTemplate = _c[0], setAppIntegrationTemplate = _c[1];
    var _d = (0, react_1.useState)(undefined), appIntegration = _d[0], setAppIntegration = _d[1];
    var _e = (0, react_1.useState)(undefined), editorJsonDataState = _e[0], setEditorJsonDataState = _e[1];
    var _f = (0, react_1.useState)(false), expandedAccordion = _f[0], setExpandedAccordion = _f[1];
    var editorDataState = editorJsonDataState
        ? JSON.parse(editorJsonDataState)
        : {
            template_id: props.appIntegrationTemplateId,
            name: "",
            secrets: {},
            setup: { variables: {} },
            resources: {}
        };
    var onResourceChangedHandler = function (identifier, data) {
        editorDataState.resources[identifier] = data;
        setEditorJsonDataState(JSON.stringify(editorDataState));
    };
    var onSettingsChangedHandler = function (e, key) {
        var data_value;
        var propKey;
        var setting;
        if (key) {
            propKey = key;
            setting = appIntegrationTemplate.definition.script.settings.find(function (setting) { return setting.key === propKey; });
            data_value = e;
        }
        else {
            var event_1 = e;
            propKey = event_1.target.dataset.key;
            setting = appIntegrationTemplate.definition.script.settings.find(function (setting) { return setting.key === propKey; });
            if (setting instanceof q_play_core_1.BooleanSetting) {
                data_value = event_1.target.checked;
            }
            else {
                data_value = event_1.target.value;
            }
        }
        if (setting instanceof q_play_core_1.BooleanSetting) {
            editorDataState.setup.variables[propKey] = data_value;
        }
        else {
            var value = setting.hydrate(data_value);
            if ((0, TypeGuards_1.isPrimitive)(value))
                editorDataState.setup.variables[propKey] = value;
        }
        setEditorJsonDataState(JSON.stringify(editorDataState));
    };
    var onCredentialsChangedHandler = function (e, key) {
        var data_value;
        var propKey;
        if (key) {
            propKey = key;
            data_value = e;
        }
        else {
            var event_2 = e;
            propKey = event_2.target.dataset.key;
            data_value = event_2.target.value;
        }
        editorDataState.secrets[propKey] = data_value;
        setEditorJsonDataState(JSON.stringify(editorDataState));
    };
    var onIntegrationNameChange = function (event) {
        editorDataState.name = event.target.value;
        setEditorJsonDataState(JSON.stringify(editorDataState));
    };
    var handleAccordionChange = function (panel) { return function (event, isExpanded) {
        setExpandedAccordion(isExpanded ? panel : false);
    }; };
    var onDeleteResource = function (identifier) {
        delete editorDataState.resources[identifier];
        setEditorJsonDataState(JSON.stringify(editorDataState));
    };
    var addResource = function () {
        var idNr = 0;
        Object.keys(editorDataState.resources).map(function (key) {
            idNr = Math.max(idNr, parseInt(key.substring(9)));
        });
        var identifier = "resource-" + (idNr + 1);
        editorDataState.resources[identifier] = { template: "", name: t("New resource"), variables: {} };
        setEditorJsonDataState(JSON.stringify(editorDataState));
        setExpandedAccordion(identifier);
    };
    var saveIntegration = function () { return __awaiter(void 0, void 0, void 0, function () {
        var integration, data;
        var _a;
        return __generator(this, function (_b) {
            switch (_b.label) {
                case 0:
                    if (!appIntegration) return [3 /*break*/, 2];
                    return [4 /*yield*/, AppIntegrationHelper_1.default.updateAppIntegration(appIntegration.id, editorDataState)];
                case 1:
                    integration = _b.sent();
                    return [3 /*break*/, 4];
                case 2:
                    editorDataState.version = (_a = appIntegrationTemplate.definition) === null || _a === void 0 ? void 0 : _a.script.version;
                    return [4 /*yield*/, AppIntegrationHelper_1.default.createAppIntegration(editorDataState)];
                case 3:
                    integration = _b.sent();
                    _b.label = 4;
                case 4:
                    if (integration) {
                        data = {
                            template_id: integration.template_id,
                            name: integration.name,
                            setup: integration.definition.setup,
                            secrets: {},
                            resources: integration.definition.resources,
                        };
                        props.setSaveError(false);
                        props.onSave(integration);
                        setAppIntegration(integration);
                        setEditorJsonDataState(JSON.stringify(data));
                    }
                    else {
                        props.setSaveError(t("Unable to save integration"));
                    }
                    return [2 /*return*/];
            }
        });
    }); };
    var loadAppIntegrationDefinition = function () { return __awaiter(void 0, void 0, void 0, function () {
        var integration, data;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!props.appIntegrationId) return [3 /*break*/, 2];
                    return [4 /*yield*/, AppIntegrationHelper_1.default.loadIntegration(props.appIntegrationId)];
                case 1:
                    integration = _a.sent();
                    setAppIntegration(integration);
                    if (!editorJsonDataState) {
                        data = {
                            template_id: integration.template_id,
                            name: integration.name,
                            setup: integration.definition.setup,
                            secrets: {},
                            resources: integration.definition.resources,
                        };
                        setEditorJsonDataState(JSON.stringify(data));
                    }
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var reloadIntegrationDefinition = function () { return __awaiter(void 0, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, loadAppIntegrationDefinition()];
        });
    }); };
    var loadAppIntegrationTemplateDefinition = function (id) { return __awaiter(void 0, void 0, void 0, function () {
        var info;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, AppIntegrationHelper_1.default.getIntegrationTemplate(id)];
                case 1:
                    info = _a.sent();
                    if (!appIntegration || Object.keys(appIntegration.definition.setup.variables).length < 1) {
                        info.definition.script.settings.map(function (setting) {
                            var defaultValue = setting.getDefaultValue();
                            if ((0, TypeGuards_1.isPrimitive)(defaultValue)) {
                                editorDataState.setup.variables[setting.key] = defaultValue;
                            }
                        });
                    }
                    setAppIntegrationTemplate(info);
                    setEditorJsonDataState(JSON.stringify(editorDataState));
                    return [2 /*return*/];
            }
        });
    }); };
    var integrationName = new q_play_core_1.StringSetting("integration-name", t("Name"));
    var primaryColumnSettings = appIntegrationTemplate === null || appIntegrationTemplate === void 0 ? void 0 : appIntegrationTemplate.definition.script.settings.filter(function (setting) {
        return setting.section !== "secondary" && setting.section !== "credentials" && setting.isVisible(editorDataState.setup.variables);
    });
    var secondaryColumnSettings = appIntegrationTemplate === null || appIntegrationTemplate === void 0 ? void 0 : appIntegrationTemplate.definition.script.settings.filter(function (setting) {
        return setting.section === "secondary" && setting.isVisible(editorDataState.setup.variables);
    });
    var credentialColumnSettings = appIntegrationTemplate === null || appIntegrationTemplate === void 0 ? void 0 : appIntegrationTemplate.definition.script.settings.filter(function (setting) {
        return setting.section === "credentials" && setting.isVisible(editorDataState.setup.variables);
    });
    (0, react_1.useEffect)(function () {
        var _a;
        props.setTitle(appIntegration
            ? (_a = editorDataState === null || editorDataState === void 0 ? void 0 : editorDataState.name) !== null && _a !== void 0 ? _a : ""
            : (editorDataState === null || editorDataState === void 0 ? void 0 : editorDataState.name)
                ? t("New integration") + ": " + editorDataState.name
                : t("New integration"));
    }, [appIntegration, editorDataState === null || editorDataState === void 0 ? void 0 : editorDataState.name]);
    (0, react_1.useEffect)(function () {
        if (props.appIntegrationId) {
            loadAppIntegrationDefinition();
        }
        else {
            setAppIntegration(undefined);
        }
    }, [props.appIntegrationId]);
    (0, react_1.useEffect)(function () {
        if (!appIntegrationTemplate) {
            var appIntegrationTemplateId = void 0;
            if (props.appIntegrationTemplateId) {
                appIntegrationTemplateId = props.appIntegrationTemplateId;
            }
            else if (appIntegration === null || appIntegration === void 0 ? void 0 : appIntegration.template_id) {
                appIntegrationTemplateId = appIntegration.template_id;
            }
            if (appIntegrationTemplateId) {
                loadAppIntegrationTemplateDefinition(appIntegrationTemplateId);
            }
        }
    }, [props.appIntegrationTemplateId, appIntegration === null || appIntegration === void 0 ? void 0 : appIntegration.template_id]);
    return (react_1.default.createElement(react_1.default.Fragment, null, appIntegrationTemplate
        ? react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", { className: AppIntegrations_module_css_1.default["integration-editor"] },
                react_1.default.createElement("div", { className: AppIntegrations_module_css_1.default["title"], style: { paddingLeft: "20px" } },
                    react_1.default.createElement("div", { className: "ns-font-family-bold", style: { color: "var(--info-color)", marginBottom: "10px" } }, appIntegrationTemplate.name)),
                react_1.default.createElement("div", { className: AppIntegrations_module_css_1.default["header"] },
                    react_1.default.createElement("div", { className: AppIntegrations_module_css_1.default["description-panel"], style: { paddingLeft: "20px" } },
                        appIntegrationTemplate.description,
                        react_1.default.createElement("div", { style: { marginTop: "15px" } }, appIntegrationTemplate.description_link
                            ? (react_1.default.createElement("div", null,
                                react_1.default.createElement("a", { href: appIntegrationTemplate.description_link, style: { color: "#507C7D" }, target: "_blank", rel: "noopener noreferrer" },
                                    react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faGlobe, style: { color: "#507C7D", width: "15px", height: "15px", marginRight: "10px" } }),
                                    t("Read more about the integration"))))
                            : react_1.default.createElement(react_1.default.Fragment, null)),
                        react_1.default.createElement(AccessControl_1.default, { optionalPermissions: props.permissions.manage, resourceType: types_1.ResourceType.INTEGRATION }, ((_a = appIntegrationTemplate.definition) === null || _a === void 0 ? void 0 : _a.setup_quick_guide)
                            ? (react_1.default.createElement("div", { className: AppIntegrations_module_css_1.default["guide-box"] }, appIntegrationTemplate.definition.setup_quick_guide.split("\n").map(function (text, key) {
                                return (react_1.default.createElement("span", { key: key },
                                    text,
                                    react_1.default.createElement("br", null)));
                            })))
                            : react_1.default.createElement(react_1.default.Fragment, null))),
                    react_1.default.createElement("div", { className: AppIntegrations_module_css_1.default["logo-panel"], style: { textAlign: "center" } },
                        react_1.default.createElement("img", { src: appIntegrationTemplate.icon, style: { width: "100%" } }))),
                react_1.default.createElement("div", null,
                    react_1.default.createElement(AccessControl_1.default, { optionalPermissions: props.permissions.manage, resourceType: types_1.ResourceType.INTEGRATION },
                        react_1.default.createElement("div", { className: AppIntegrations_module_css_1.default["variable-editor"] },
                            react_1.default.createElement("div", { style: { width: "35%" } },
                                react_1.default.createElement("div", { className: "ns-font-family-bold", style: { color: "var(--info-color)", marginBottom: "10px" } },
                                    t("Global settings"),
                                    ":"),
                                react_1.default.createElement(q_play_components_1.SettingsComponent, { key: integrationName.key, value: (_b = editorDataState.name) !== null && _b !== void 0 ? _b : "", disabled: false, setting: integrationName, onChange: onIntegrationNameChange }),
                                primaryColumnSettings.map(function (setting) {
                                    var _a;
                                    return (react_1.default.createElement(q_play_components_1.SettingsComponent, { key: setting.key, value: (_a = editorDataState.setup.variables[setting.key]) !== null && _a !== void 0 ? _a : "", disabled: setting.isDisabled(editorDataState.setup.variables), setting: setting, onChange: onSettingsChangedHandler }));
                                })),
                            react_1.default.createElement("div", null,
                                react_1.default.createElement("div", { className: "ns-font-family-bold", style: { marginBottom: "10px" } }, "\u00A0"),
                                secondaryColumnSettings.map(function (setting) {
                                    var _a;
                                    return (react_1.default.createElement(q_play_components_1.SettingsComponent, { key: setting.key, value: (_a = editorDataState.setup.variables[setting.key]) !== null && _a !== void 0 ? _a : "", disabled: setting.isDisabled(editorDataState.setup.variables), setting: setting, onChange: onSettingsChangedHandler }));
                                })),
                            react_1.default.createElement("div", { style: { width: "30%" } }, credentialColumnSettings.length > 0
                                ? react_1.default.createElement(react_1.default.Fragment, null,
                                    react_1.default.createElement("div", { className: "ns-font-family-bold", style: { color: "var(--info-color)", marginBottom: "10px" } },
                                        t("Credentials"),
                                        ":"),
                                    credentialColumnSettings.map(function (setting) {
                                        var _a, _b;
                                        return (react_1.default.createElement(q_play_components_1.SettingsComponent, { key: setting.key, value: setting.secret ? ((_a = editorDataState.secrets[setting.key]) !== null && _a !== void 0 ? _a : "") : ((_b = editorDataState.setup.variables[setting.key]) !== null && _b !== void 0 ? _b : ""), disabled: setting.isDisabled(editorDataState.setup.variables), setting: setting, onChange: setting.secret ? onCredentialsChangedHandler : onSettingsChangedHandler }));
                                    }))
                                : react_1.default.createElement(react_1.default.Fragment, null)))),
                    react_1.default.createElement("div", { className: AppIntegrations_module_css_1.default["resource-accordion-wrapper"], "data-cy": "integrationResourceList", style: Object.keys(editorDataState.resources).length < 1 ? { maxWidth: "98%" } : {} }, Object.keys(editorDataState.resources).length < 1 ? (react_1.default.createElement("div", { className: AppIntegrations_module_css_1.default["no-resource-header"], "data-cy": "noResourcesPlaceholder" }, t("No resources"))) : (react_1.default.createElement("div", null, editorDataState.resources &&
                        Object.keys(editorDataState.resources).map(function (identifier) {
                            var isExpanded = expandedAccordion === identifier;
                            return (react_1.default.createElement("div", { key: identifier, style: {
                                    display: "flex",
                                    justifyContent: "space-between",
                                    marginBottom: "5px",
                                } },
                                react_1.default.createElement(AppIntegrationResourceAccordion_1.default, { permissions: props.permissions, onResourceChangedHandler: onResourceChangedHandler, identifier: identifier, appIntegrationTemplate: appIntegrationTemplate, appIntegration: appIntegration, resourceEditorData: editorDataState.resources[identifier], reloadIntegrationDefinition: reloadIntegrationDefinition, onDelete: onDeleteResource, isActive: isExpanded, expanded: isExpanded, onChange: handleAccordionChange(identifier) }),
                                react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: pro_solid_svg_icons_1.faTrashCan, style: {
                                        cursor: "pointer",
                                        color: "var(--info-color)",
                                        marginLeft: "10px",
                                        marginTop: isExpanded ? "24px" : "23px",
                                    }, onClick: function (e) {
                                        e.stopPropagation();
                                        onDeleteResource(identifier);
                                    } })));
                        })))),
                    react_1.default.createElement(AccessControl_1.default, { optionalPermissions: props.permissions.manage, resourceType: types_1.ResourceType.INTEGRATION },
                        react_1.default.createElement(q_play_components_2.Button, { variant: "primary", size: "normal", className: "d-flex justify-content-center align-items-center p-0 mt-3", onClick: addResource, style: { position: "relative", top: "-6px", width: "98%" }, dataCy: "integrationAddResourceButton" },
                            react_1.default.createElement("span", { className: "d-flex justify-content-center align-items-center", style: { height: "40px" } }, "+")))),
                react_1.default.createElement("div", { className: AppIntegrations_module_css_1.default["footer"] },
                    react_1.default.createElement("div", null, props.saveError && (react_1.default.createElement("span", { style: { color: "var(--error-color)" } }, props.saveError))),
                    react_1.default.createElement("div", { className: AppIntegrations_module_css_1.default["footer-buttons"] },
                        react_1.default.createElement(q_play_components_2.Button, { onClick: props.closeModal, "data-cy": "closeIntegrationButton", text: t("Close") }),
                        react_1.default.createElement(AccessControl_1.default, { optionalPermissions: props.permissions.manage, resourceType: types_1.ResourceType.INTEGRATION },
                            react_1.default.createElement(q_play_components_2.Button, { text: t("Save"), onClick: saveIntegration, "data-cy": "saveIntegrationButton" }))))))
        : react_1.default.createElement("div", null, t("Loading..."))));
};
exports.default = AppIntegrationEditor;
